export function laravelSlug(str: string): string {
    return str
        // Normalize accented characters (same as Laravel’s Str::ascii)
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "") // remove diacritics

        // Lowercase
        .toLowerCase()

        // Replace any non-letter/number with a dash
        .replace(/[^a-z0-9]+/g, "-")

        // Remove leading/trailing dashes
        .replace(/^-+|-+$/g, "");
}
